import React from 'react';
import './index.scss';

const BORDER_PATH = {
  'f': <circle className='f' cx="250" cy="168" r="140" strokeWidth="25" strokeDasharray="42 20" />,
  'm': <circle className='m' cx="205" cy="312" r="140" strokeWidth="25" strokeDasharray="42 20" />,
  'u': <circle className='u' cx="250" cy="250" r="220" strokeWidth="40" strokeDasharray="70 35" />,
};

const ARROW_PATH = {
  'f': <path d="M 235 302.475 H 265 V 400 H 337.5 V 430 H 265 V 477.475 H 235 V 430 H 162.5 V 400 H 235 Z" />,
  'm': <path d="M 434.575 151.929 H 541.575 L 541.575 101.929 L 624.575 166.929 L 541.575 231.929 L 541.575 181.929 H 434.575 V 151.929 Z" transform="matrix(0.787963, -0.615722, 0.615722, 0.787963, -124.389229, 365.202209)" />,
  'u': null,

};

const DISEASE_PATH = {
  'affected': {
    'f': <path d="M 177 97 L 317 237 M 317 97 L 177 237" strokeWidth="22" />,
    'm': <path d="M 135 242 L 275 382 M 275 242 L 135 382" strokeWidth="22" />,
    'u': <path d="M 140 140 L 360 360 M 360 140 L 140 360" strokeWidth="30" />,
  },
  'carrier': {
    'f': <circle cx="250" cy="168" r="44" />,
    'm': <circle cx="205" cy="312" r="44" />,
    'u': <circle cx="250" cy="250" r="70" />,
  },
  'unaffected': {},
  'no_result': {
    'f': <text x="195" y="250" fontSize="220">?</text>,
    'm': <text x="150" y="390" fontSize="220">?</text>,
    'u': <text x="155" y="370" fontSize="350">?</text>,
  },
  'waiting': {},
};

export default function KmapIcon({ cnStatus, disease, sex = 'u', ...restProps }) {
  return (
    <svg
      className={`biomaterial ${cnStatus}`}
      height={30}
      width={30}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g className='arrow'>
        {ARROW_PATH[sex]}
      </g>
      <g className='border'>
        {BORDER_PATH[sex]}
      </g>
      <g className='disease' stroke='black'>
        {DISEASE_PATH[disease][sex]}
      </g>
    </svg>
  );
}